var _excluded = ["disabled", "type", "page", "selected", "i18n"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import mergeRefs from 'react-merge-refs';
import useFocusVisible from '../utils/use_focus_visible';
import { IconChevronStart, IconChevronEnd } from '../utils/chevron_icon';
import UtilityButton from '../shared/utility_button';
import paginationI18n from './i18n';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PaginationItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      disabled = false,
      type = 'page',
      page = '1',
      selected = false,
      i18n
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded);
  var [focusVisible, setFocusVisible] = React.useState(false);
  if (disabled && focusVisible) {
    setFocusVisible(false);
  }
  var {
    handleBlurVisible,
    handleFocusVisible,
    ref: focusVisibleRef
  } = useFocusVisible();
  var handleRef = mergeRefs([ref, focusVisibleRef]);
  var handleFocus = event => {
    if (handleFocusVisible(event)) {
      setFocusVisible(true);
    }
  };
  var handleBlur = event => {
    if (focusVisible) {
      handleBlurVisible(event);
      setFocusVisible(false);
    }
  };
  var ariaLabel = '';
  if (type === 'page' && selected) {
    var _i18n$currentPage;
    ariaLabel = (i18n === null || i18n === void 0 || (_i18n$currentPage = i18n.currentPage) === null || _i18n$currentPage === void 0 ? void 0 : _i18n$currentPage.replace('%{pageNumber}', page)) || paginationI18n.currentPage.replace('%{pageNumber}', page);
  } else if (type === 'page') {
    var _i18n$goto;
    ariaLabel = (i18n === null || i18n === void 0 || (_i18n$goto = i18n.goto) === null || _i18n$goto === void 0 ? void 0 : _i18n$goto.replace('%{pageNumber}', page)) || paginationI18n.goto.replace('%{pageNumber}', page);
  } else if (type === 'next' || type === 'previous') {
    ariaLabel = i18n && i18n[type] || paginationI18n[type];
  }
  var paginationButtonProps = {
    'aria-label': ariaLabel,
    'data-focused': focusVisible ? true : undefined,
    className: type,
    disabled,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handleRef,
    tabIndex: disabled ? -1 : 0
  };
  return ___EmotionJSX(React.Fragment, null, type === 'ellipsis' && ___EmotionJSX("div", {
    ref: ref,
    className: "ellipsis"
  }, "..."), type === 'page' && ___EmotionJSX("button", _extends({
    type: "button"
  }, other, paginationButtonProps), page), (type === 'previous' || type === 'next') && ___EmotionJSX(UtilityButton, _extends({
    icon: type === 'previous' ? ___EmotionJSX(IconChevronStart, null) : ___EmotionJSX(IconChevronEnd, null)
  }, other, paginationButtonProps)));
});
PaginationItem.displayName = 'PaginationItem';
export default PaginationItem;